import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
    typography: {
        fontFamily: `"Mulish", "Helvetica", "Arial", sans-serif`,
    },
    palette: {
        primary: {
            main: '#1c1c1c',
        },
        secondary: {
            main: '#747474',
        },
    },
    components: {
        PrimaryButton: {
            styleOverrides: {
                root: {
                    color: '#fff',
                    '&:hover': {
                        backgroundColor: '#1c1c1c',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderColor: '#c4c4c4',
                    color: '#5d5d5d',
                    boxShadow: 'none',
                    textTransform: 'uppercase',
                    '&:hover': {
                        opacity: '0.9',
                        borderColor: '#c4c4c4',
                        backgroundColor: '#f8f8f8',
                        boxShadow: 'none',
                    },
                },
            },
        },
    },
})
